export const linkedPageNodeName = 'linkedPage';
export const linkedPageSuggestMarkName = 'linkedPageSuggest';
export const linkedPageMarkdownEnclosure = 'MARKDOWN_LINKED_PAGE';
export const linkedPagePluginKeyName = 'linkedPage';
